module.exports = __webpack_public_path__ + "img/Weapon_238.366b2358.png";